import { Button } from '$components'
import { useEditAppointmentNotesForm } from './index'

export function EditNotesControls() {
  const { onCancel, isLoading } = useEditAppointmentNotesForm()

  return (
    <div className="flex gap-stack">
      <Button
        type="button"
        variant="secondary"
        onClick={onCancel}
        disabled={isLoading}
      >
        Cancel
      </Button>

      <Button
        type="submit"
        isLoading={isLoading}
      >
        Save Changes
      </Button>
    </div>
  )
}
